import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {checkIsCrmIntegrationConnected} from '../../../../../../../../src/helpers/integrationHelpers';
import {ResolveDispatchProps} from '../../../../../../../../src/helpers/reduxHelpers';
import {
  makeMapDispatchToProps,
  makeMapStateToProps,
  ResolveStateProps,
} from '../../../../../../../../src/helpers/reselectHelpers';
import {CrmSyncSourcesEnum} from '../../../../../../../../src/models/api/crmSyncModel';
import {
  getIsCrmSyncLoading,
  makeGetAccountCrmSyncViaSource,
  makeGetCardCrmSyncViaSource,
} from '../../../../../../../../src/store/data/crmSync/crmSyncSelectors';
import {getCrmIntegration} from '../../../../../../../../src/store/data/integrations/integrationSelectors';
import {
  getHasCrmSyncFullPageSalesforce,
  getHasMicrosoftDynamicsAccountSync,
} from '../../../../../../../../src/store/featureFlags/featureFlagsSelectors';
import {ContactsManagerParametersTypesEnum} from '../../../../../../../../src/store/panels/contacts/contactsManager/parameters/contactsManagerParameters';
import {ContactsManagerPanelId} from '../../../../../../../../src/store/panels/panelStateBase';
import {navigateToLinkAction} from '../../../../../../../../src/store/stateless/navigationActions';
import {CrmSyncsPage} from './crmSyncsPage';

/*
 * Props.
 */

interface CrmSyncsPageContainerPublicProps {
  panelId: ContactsManagerPanelId;
  source: CrmSyncSourcesEnum;
  isOnErrorsPage: boolean;
  previousPageType?: ContactsManagerParametersTypesEnum;
}

type CrmSyncsPageContainerStateProps = ResolveStateProps<typeof mapStateToProps>;
type CrmSyncsPageContainerDispatchProps = ResolveDispatchProps<typeof mapDispatchToProps>;
export type CrmSyncsPageContainerProps = CrmSyncsPageContainerPublicProps &
  CrmSyncsPageContainerStateProps &
  CrmSyncsPageContainerDispatchProps;

/*
 * Selectors.
 */

function makeGetExternalBaseUrl() {
  return createSelector(
    [makeGetAccountCrmSyncViaSource(), makeGetCardCrmSyncViaSource()],
    (accountCrmSync, cardCrmSync) => accountCrmSync?.externalUrl || cardCrmSync?.externalUrl,
  );
}

const getIsConnected = createSelector([getCrmIntegration], checkIsCrmIntegrationConnected);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CrmSyncsPageContainerPublicProps>()(() => ({
  externalBaseUrl: makeGetExternalBaseUrl(),
  hasCrmSyncFullPageSalesforce: getHasCrmSyncFullPageSalesforce,
  hasMicrosoftDynamicAccountSync: getHasMicrosoftDynamicsAccountSync,
  accountCrmSync: makeGetAccountCrmSyncViaSource(),
  cardCrmSync: makeGetCardCrmSyncViaSource(),
  isConnected: getIsConnected,
  isCrmSyncLoading: getIsCrmSyncLoading,
}));

const mapDispatchToProps = makeMapDispatchToProps<CrmSyncsPageContainerPublicProps>()(() => ({
  navigateToLink: navigateToLinkAction,
}));

export const CrmSyncsPageContainer = connect(mapStateToProps, mapDispatchToProps)(CrmSyncsPage);
